<script>
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  
  export default {
    components: { datepicker },
    props: {
      webFormRespostasParticipacaoAcionaria: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        participacaoAcionaria: this.campos(),
      }
    },
    methods: {
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (valido) {
              this.adicionar();
            }
          })
      },
      validarDadosNaoEnviados(){
        if(this.participacaoAcionaria.cnpj != '')
          return false
        if(this.participacaoAcionaria.nomeEmpresa != '')
          return false;
        if(this.participacaoAcionaria.percentual != '')
          return false

        return true;
      },
      deletar(indice) {
        this.webFormRespostasParticipacaoAcionaria.splice(indice, 1);
      },
      editar(indice) {
        const participacaoAcionaria = this.webFormRespostasParticipacaoAcionaria[indice];
        this.webFormRespostasParticipacaoAcionaria.splice(indice, 1);

        this.participacaoAcionaria.id = participacaoAcionaria.id;
        this.participacaoAcionaria.cnpj = participacaoAcionaria.cnpj;
        this.participacaoAcionaria.nomeEmpresa = participacaoAcionaria.nomeEmpresa;
        this.participacaoAcionaria.percentual = participacaoAcionaria.percentual;
      },
      async adicionar() {
        const copiaParticipacaoAcionaria = Object.assign(this.participacaoAcionaria);
        
        this.participacaoAcionaria = this.campos();
        
        this.webFormRespostasParticipacaoAcionaria.push(copiaParticipacaoAcionaria);

        this.$validator.reset();
      },
      campos() {
        return {
          id: '',
          cnpj: '',
          nomeEmpresa: '',
          percentual: '',
        }
      }
    }
  }
</script>

<template>
  <div>

    <div class="table-responsive">
      <table class="table table-hover table-pointer">
        <thead>
        <tr>
          <th>CNPJ</th>
          <th>Nome da Empresa</th>
          <th>Percentual</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(participacaoAcionaria, indice) in webFormRespostasParticipacaoAcionaria">
            <td>{{ participacaoAcionaria.cnpj }}</td>
            <td>{{ participacaoAcionaria.nomeEmpresa }}</td>
            <td>{{ participacaoAcionaria.percentual }}</td>
            <td class="action">
              <button type="button"
                      class="btn btn-warning btn-xs"
                      @click="editar(indice)">
                <i class="fa fa-edit"></i>
              </button>
            </td>
            <td class="action">
              <button type="button"
                      class="btn btn-danger btn-xs"
                      @click="deletar(indice)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        <tr v-if="webFormRespostasParticipacaoAcionaria.length === 0">
          <td colspan="3" class="text-center">Nenhum registro encontrado.</td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('cnpj')}">
          <label class="control-label" for="cnpj">CNPJ</label>

          <input type="text"
                 class="form-control"
                 id="cnpj"
                 v-model="participacaoAcionaria.cnpj"
                 v-mascara="'cnpj'"
                 data-vv-name="cnpj"
                 data-vv-as="CNPJ"
                 v-validate="'required|cnpj'">

          <p class="text-danger" v-show="errors.has('cnpj')">{{ errors.first('cnpj') }}</p>
        </div>
      </div>

      <div class="col-lg-8">
        <div class="form-group required" :class="{'has-error': errors.has('nomeEmpresa')}">
          <label class="control-label" for="nomeEmpresa">Nome da Empresa</label>

          <input type="text"
                 class="form-control"
                 id="nomeEmpresa"
                 maxlength="100"
                 v-model="participacaoAcionaria.nomeEmpresa"
                 data-vv-name="nomeEmpresa"
                 data-vv-as="nome da empresa"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('nomeEmpresa')">{{ errors.first('nomeEmpresa') }}</p>
        </div>
      </div>

      <div class="col-lg-2">
        <div class="form-group required" :class="{'has-error': errors.has('percentual')}">
          <label class="control-label" for="percentual">Percentual</label>

          <input type="text"
                 class="form-control text-center"
                 id="percentual"
                 v-model="participacaoAcionaria.percentual"
                 v-mascara="'porcentagem'"
                 maxlength="5"
                 data-vv-name="percentual"
                 data-vv-as="percentual"
                 v-validate="'required'">

          <p class="text-danger" v-show="errors.has('percentual')">{{ errors.first('percentual') }}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="form-group">
          <button
            type="button"
            class="btn btn-success"
            @click="validar">
            <i class="fa fa-plus"></i> Adicionar empresa
          </button>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/web-fornecedor/componentes/compartilhado/WebFormRespostasParticipacaoAcionaria.vue